import script from "./Accordian.vue?vue&type=script&setup=true&lang=ts"
export * from "./Accordian.vue?vue&type=script&setup=true&lang=ts"

import "./Accordian.vue?vue&type=style&index=0&id=6e910c8c&lang=css"

const __exports__ = script;

export default __exports__